import { GisSearchRequest } from './gis.search.request';

export class GisInvoiceSearchRequest extends GisSearchRequest {
  public DeliveryNoteNumber: number;
  public InvoiceNumber: number;
}
